import React from "react";
import { useNavigate } from "react-router-dom";
import AdCard from "../../../components/common/AdCard";
import { getAdsForSection } from "../../../config/ads";

const countries = [
  {
    name:
      "Register Before 180 Days or Leave: India Tightens Foreigner Registration Rules",
    path: "/articles/immigration-and-foreigners-rules",
    flag:
      "https://www.caindelhiindia.com/blog/wp-content/uploads/2024/06/FRRO-.png",
    description:
      "The Union Ministry of Home Affairs has amended the Immigration and Foreigners Rules, 2025 — removing the 14-day grace period and requiring foreign nationals to register with FRRO or FRO before their 180-day stay expires.",
  },
  {
    name: "2026 U.S. Immigration Policies affecting Indian/Bharat Nationals",
    path: "/news/immigration-2026/us",
    flag:
      "https://c.ndtvimg.com/2025-11/gg39q6h8_us-immigration-fee_625x300_21_November_25.jpeg?downsize=545:307",
    description:
      "The U.S. has introduced sweeping immigration reforms in 2026 affecting Indian nationals on H-1B, L-1, and student visas. Key changes include stricter documentation, new fee structures, and updated processing timelines.",
    source: "IMM News",
  },
  {
    name: "UK Immigration Reforms 2026 for Indian/Bharat Nationals",
    path: "/news/uk-immigration-2026",
    flag:
      "https://cdn.prod.website-files.com/63e4ca13cde96a2d7995426a/6830453572ce41fcf087bf20_4.png",
    description: "UK immigration reforms 2026 updates.",
    source: "IMM News",
  },
  {
    name: "Canada's 2026 Immigration Reset Hits Bharat/Indians",
    path: "/news/canada-immigration-reset-2026",
    flag:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTub6xV8tn0OAdlmFNTT59LWlNow3OMsdGfCQ&s",
    description: "Canada immigration reset 2026 updates.",
    source: "IMM News",
  },
  {
    name: "Australia Tightens Visa Rules in 2026",
    path: "/news/australia-visa-reforms-2026",
    flag:
      "https://jamesonlaw.com.au/wp-content/uploads/emplibot/Are-Australia_s-Immigration-Laws-Strict__1749870647.webp",
    description: "Australia visa rule changes 2026.",
    source: "IMM News",
  },
  {
    name: "Germany's 2026 Immigration Push",
    path: "/news/germany-immigration-push-2026",
    flag:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTAd5p5pbyoXjXmPIMcHt9n-aaFWsEMuHa1DQ&s",
    description: "Germany immigration push 2026 updates.",
    source: "IMM News",
  },
  {
    name: "Middle East: Stricter Enforcement, Selective Easing",
    path: "/news/middle-east-immigration-2026",
    flag:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRsNi2gxguTJK0iop0-Cx9Ti0KvAlP_NTyKVQ&s",
    description: "Middle East immigration enforcement updates 2026.",
    source: "IMM News",
  },
  {
    name: "New Zealand: Higher Costs, Stricter Rules, Selective Pathways",
    path: "/news/new-zealand-immigration-reset-2026",
    flag:
      "https://media.licdn.com/dms/image/v2/C4E12AQHISBqlsC3Dcw/article-cover_image-shrink_720_1280/article-cover_image-shrink_720_1280/0/1542681225790?e=2147483647&v=beta&t=wm_Gyay4KA2LM1LyOYB-felzKrCGZIFv50Ir8gXbAIs",
    description: "New Zealand immigration changes 2026.",
    source: "IMM News",
  },
  {
    name:
      "Singapore: No-Boarding Directive Brings Stricter Pre-Departure Checks",
    path: "/news/singapore-immigration-2026",
    flag:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSvy2Tg_e5g5FIRdW4_yF7OwCdSxbRwo47VnQ&s",
    description: "Singapore immigration directive updates 2026.",
    source: "IMM News",
  },
];

/* ── Small card (reusable) ── */
function ImmSmallCard({ item }) {
  const navigate = useNavigate();
  return (
    <div className="imm-small-card" onClick={() => navigate(item.path)}>
      <img src={item.flag} alt={item.name} className="imm-small-img" />
      <div className="imm-small-body">
        <span className="imm-source">{item.source}</span>
        <div className="imm-small-title">{item.name}</div>
        <div className="imm-small-desc">{item.description}</div>
        <span className="imm-readmore">Read More →</span>
      </div>
    </div>
  );
}

/* ── Big card ── */
function ImmBigCard({ item }) {
  const navigate = useNavigate();
  return (
    <div className="imm-big-card" onClick={() => navigate(item.path)}>
      <div className="imm-big-image">
        <img src={item.flag} alt={item.name} />
      </div>
      <div className="imm-big-body">
        <span className="imm-source">{item.source}</span>
        <div className="imm-big-title">{item.name}</div>
        <div className="imm-big-desc">{item.description}</div>
        <span className="imm-readmore">Read More →</span>
      </div>
    </div>
  );
}

/* ── Main Component ── */
const ImmNewsSection = ({
  title = "Immigration News 2026",
  category = "immigration",
}) => {
  const [heroItem, ...rest] = countries;

  // Row 2: items 1–4, Row 3: items 5–8
  const row2 = rest.slice(0, 4);
  const row3 = rest.slice(4, 8);

  const { ad1 } = getAdsForSection(category || title);

  return (
    <>
      <div className="imm-section">
        <div className="imm-section-title">{title}</div>

        {/* ROW 1 — Big Card + Ad Column (3fr 1fr) */}
        <div className="imm-row-1">
          <ImmBigCard item={heroItem} />
          <div className="imm-ad-column">{ad1 && <AdCard ad={ad1} />}</div>
        </div>

        {/* ROW 2 — 4 columns */}
        <div className="imm-news-row">
          {row2.map((item, i) => (
            <ImmSmallCard key={`r2-${i}`} item={item} />
          ))}
        </div>

        {/* ROW 3 — 4 columns */}
        <div className="imm-news-row">
          {row3.map((item, i) => (
            <ImmSmallCard key={`r3-${i}`} item={item} />
          ))}
        </div>
      </div>

      <style>{`
        .imm-section {
          margin-bottom: 40px;
        }

        /* Section Title */
        .imm-section-title {
          margin: 30px 0 10px;
          font-size: 22px;
          font-weight: bold;
          color: #1a1a1a;
          border-left: 4px solid #0066cc;
          padding-left: 10px;
        }

        /* ── ROW 1: BIG CARD + AD ── */
        .imm-row-1 {
          display: grid;
          grid-template-columns: 3fr 1fr;
          gap: 15px;
          margin-bottom: 15px;
        }

        .imm-ad-column {
          display: flex;
          flex-direction: column;
        }

        .imm-big-card {
          display: flex;
          background: #fff;
          border-radius: 12px;
          overflow: hidden;
          box-shadow: 0 2px 10px rgba(0,0,0,0.08);
          cursor: pointer;
          transition: transform 0.2s ease, box-shadow 0.2s ease;
          min-height: 300px;
        }

        .imm-big-card:hover {
          transform: translateY(-4px);
          box-shadow: 0 8px 24px rgba(0,0,0,0.14);
        }

        .imm-big-image {
          flex: 0 0 50%;
          overflow: hidden;
        }

        .imm-big-image img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
          transition: transform 0.4s ease;
        }

        .imm-big-card:hover .imm-big-image img {
          transform: scale(1.04);
        }

        .imm-big-body {
          flex: 1;
          padding: 28px 32px;
          display: flex;
          flex-direction: column;
          justify-content: center;
        }

        .imm-big-title {
          font-size: 22px;
          font-weight: 800;
          color: #111;
          line-height: 1.35;
          margin-bottom: 14px;
          display: -webkit-box;
          -webkit-line-clamp: 4;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }

        .imm-big-desc {
          font-size: 14px;
          color: #555;
          line-height: 1.65;
          display: -webkit-box;
          -webkit-line-clamp: 4;
          -webkit-box-orient: vertical;
          overflow: hidden;
          margin-bottom: 18px;
        }

        /* ── NEWS ROWS ── */
        .imm-news-row {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 15px;
          margin-bottom: 15px;
        }

        /* ── SMALL CARD ── */
        .imm-small-card {
          background: #fff;
          border-radius: 10px;
          overflow: hidden;
          box-shadow: 0 2px 10px rgba(0,0,0,0.08);
          cursor: pointer;
          transition: transform 0.2s ease, box-shadow 0.2s ease;
          display: flex;
          flex-direction: column;
        }

        .imm-small-card:hover {
          transform: translateY(-4px);
          box-shadow: 0 4px 16px rgba(0,0,0,0.12);
        }

        .imm-small-img {
          width: 100%;
          height: 180px;
          object-fit: cover;
          display: block;
        }

        .imm-small-body {
          padding: 12px;
          display: flex;
          flex-direction: column;
          flex-grow: 1;
        }

        .imm-small-title {
          font-size: 15px;
          font-weight: 700;
          color: #222;
          line-height: 1.4;
          margin-bottom: 6px;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }

        .imm-small-desc {
          font-size: 13px;
          color: #666;
          line-height: 1.5;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          margin-bottom: 8px;
        }

        /* Shared */
        .imm-source {
          font-size: 12px;
          font-weight: 700;
          color: #0066cc;
          text-transform: uppercase;
          letter-spacing: 0.7px;
          margin-bottom: 8px;
          display: block;
        }

        .imm-readmore {
          font-size: 13px;
          font-weight: 600;
          color: #0066cc;
          margin-top: auto;
        }

        /* ── RESPONSIVE ── */
        @media (max-width: 1200px) {
          .imm-news-row {
            grid-template-columns: repeat(2, 1fr);
          }
          .imm-row-1 {
            grid-template-columns: 1fr;
          }
          .imm-ad-column {
            display: none;
          }
        }

        @media (max-width: 968px) {
          .imm-big-card {
            flex-direction: column;
          }
          .imm-big-image {
            flex: none;
            height: 240px;
          }
        }

        @media (max-width: 768px) {
          .imm-news-row {
            grid-template-columns: repeat(2, 1fr);
          }
          .imm-big-title {
            font-size: 18px;
          }
        }

        @media (max-width: 480px) {
          .imm-news-row {
            grid-template-columns: 1fr;
          }
          .imm-big-title {
            font-size: 16px;
          }
          .imm-big-body {
            padding: 16px;
          }
        }
      `}</style>
    </>
  );
};

export default ImmNewsSection;
